import { useEffect, useState } from 'react';
export const useScrollbar = (refHost) => {
    const [compData, setCompData] = useState({
        hidden: true,
        height: 0
    });
    const [topPos, setTopPos] = useState(0);
    const scrollHandler = () => {
        const scrollHostElement = refHost.current;
        if (scrollHostElement === null)
            return;
        const { scrollHeight, scrollTop } = scrollHostElement;
        setTopPos(scrollTop / scrollHeight * 100);
    };
    const heightHandler = () => {
        const scrollHostElement = refHost.current;
        if (scrollHostElement === null)
            return;
        const { clientHeight, scrollHeight } = scrollHostElement;
        setCompData({
            height: clientHeight / scrollHeight * 100,
            hidden: scrollHeight === clientHeight
        });
    };
    useEffect(() => {
        const scrollHostElement = refHost.current;
        if (scrollHostElement === null)
            return;
        const resizeObserver = new ResizeObserver((entries) => {
            entries.forEach(heightHandler);
        });
        for (const child of scrollHostElement.children) {
            resizeObserver.observe(child);
        }
        scrollHostElement.addEventListener('scroll', scrollHandler);
        return () => {
            resizeObserver.disconnect();
            scrollHostElement.removeEventListener('scroll', scrollHandler);
        };
    }, []);
    return {
        scrollbarHidden: compData.hidden,
        scrollbarSliderHeight: compData.height,
        scrollbarSliderTop: topPos
    };
};
